import { render, staticRenderFns } from "./CourseLearningProgress.vue?vue&type=template&id=1d3ab8f3&scoped=true&lang=pug&"
import script from "./CourseLearningProgress.vue?vue&type=script&lang=ts&"
export * from "./CourseLearningProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ab8f3",
  null
  
)

export default component.exports